import React, { Component, useState, useEffect,  } from 'react';
import HeaderPage from '../../Components/HeaderPages';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Spinner  } from "react-awesome-spinners";
import Aviso from '../../Components/Aviso';
import CaixaInforme from '../../Components/CaixaInforme';
import Butao from '../../Components/Butao_list';
import Select from 'react-select';
import Pagination from '../../Components/Pagination';
import TACriarCat from './TACriarCat';
import TATransferirCat from './TATransferirCat';
import TAEditarCatg from './TAEditarCatg';
import Api from '../../Api';
import FinderSelect from 'react-finderselect';


export default ({ InfIdUse, InfIdConta, DadCont, IdConta, IdUse, CidEst, Dados, setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo,
   setAlertTipo, Avisando, setAvisando}) => {
      const [Offset, setOffset] = useState(0);
      const [Limit, setLimit] = useState(10);
      const [Quant, setQuant] = useState(0);
      const [Pag1, setPag1] = useState(false);
      const [Pag2, setPag2] = useState(false);
      const [Titulo, setTitulo] = useState("Categorias de Exercícios");
      const [Time, setTime] = useState("")
      const [UsuariosContServ, setUsuariosContServ] = useState([]);
      const [Lista, setLista] = useState(["list"]);
      const [Carreg, setCarreg] = useState(false);
      const [Cont, setCont] = useState(0);
      const [Id, setId] = useState("");
      const [Nome, setNome] = useState("");
      const [Telefone, setTelefone] = useState("");
      const [AddList, setAddList] = useState(null);
      const [ResuComp, setResuComp] = useState("");
      const [VerResuComp, setVerResuComp] = useState(false);
      const [ListContas, setListContas] = useState([]);
      const [ListContasTel, setListContasTel] = useState([]);
      const [ContasNome, setContasNome] = useState([]);
      const [ContasTel, setContasTel] = useState([]);
      const [IdContRes, setIdContRes] = useState(IdConta);
      const [NomeConta, setNomeConta] = useState("");
      const [Progress, setProgress] = useState(10);
      const [ListEsp, setListEsp] = useState({});
      const [AtivosTranferir, setAtivosTranferir] = useState(false);
      
      useEffect(() => {
        
      }, [])

      useEffect(() => {
      setLista(["list"])
       ListApp();     
      }, [IdContRes])

      useEffect(() => {
           
      }, [Lista])

      useEffect(() => {
         if(AddList !== null){
          AdicionandoLista()
          
         }
       }, [AddList])
  

      useEffect(() => {
      
        Listando(); 
        
       }, [UsuariosContServ])

       useEffect(() => {
        Listando();
       }, [Offset])

       useEffect(() => {
                listandoContas();     
               }, [])
     
        useEffect(() => {
            if(ResuComp !== "" && ResuComp !== "Escolha" ){
                PesqResultComp();
            }
           }, [ResuComp])
     
        

           const listandoContas = async ()=>{
       
            await Api.TAListClientesSelect(Dados, setListContas, setListContasTel);
        
          }
            

           const PesqResultComp = ()=>{
              var Regis = true
              
              if(ResuComp === "0"){
              setVerResuComp(true);
              let listra1 = [];
              for(let i in UsuariosContServ ) {
           //if(UsuariosContServ[i].Telefone.toLowerCase().includes(ResuTel.toLowerCase() ) {
                  if( UsuariosContServ[i].QuantCompra === 0 ) {
                    listra1.push({
                      id: UsuariosContServ[i].id,
                      DataCadas:UsuariosContServ[i].DataCadas,
                      ativo:UsuariosContServ[i].ativo, 
                      Cidade: UsuariosContServ[i].Cidade,
                      Estado: UsuariosContServ[i].Estado,
                      EntrouSist:UsuariosContServ[i].EntrouSist,
                      Indicador:UsuariosContServ[i].Indicador,
                      Nome:UsuariosContServ[i].Indicador,
                      QuantCompra:UsuariosContServ[i].QuantCompra,
                      ReceberMsg:UsuariosContServ[i].ReceberMsg,
                      Registrado:UsuariosContServ[i].Registrado,
                      Telefone:UsuariosContServ[i].Telefone,   
                  });   
                  }
                 
                }
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              }
             
             
               
            } 

      
     
          const ListApp = async ()=>{
            if (navigator.onLine) {
              console.log("entra aqui")
              setLista(["list"]);
             setCarreg(true);
             await Api.TAListCategorias(Dados, IdContRes, setQuant, setUsuariosContServ, setCarreg, setProgress);
             
            } else {
              setAlert("Sem Internet");
              setAlertTipo("danger");
            }

               
          }
        const AdicionandoLista = async ()=>{
           if(Lista[0] === "list"){
                       setLista([
                         {
                           list:AddList
                         }]);
           
                     } else {
                     setLista([
                         {
                           list:AddList
                         },
                         ...Lista,
                       ]);
                     }
        
          }

          const Listando = async ()=>{
                 
                  const cal1 = Quant/Limit;
                  const cal2 = Math.trunc(cal1);
                  const cal3 = cal2*10;
                  const cal4 = Quant - cal3;
                  if(Offset === cal3) {
                      
                          const inicio = Offset;
                          const fim = Quant;
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                          
                    

                          }

                  } else {

                          const inicio = Offset;
                          const fim = (Offset + Limit) 
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                           
                   

                        }
                  

                    } 

                    var num= Cont + 1;
                    setCont(num);
                    if(Cont === 1){
                      setCarreg(false); 
                    }          
                         
          }

          function confirma() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
           
          }
          function cancelar() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
          }

          const Fechar = ()=>{
            setPag2(false);
            setPag1(false);
             setAtivosTranferir(false)
          }


               
               


                

         

               const Pagina1 = ()=>{
                 setPag1(true);
                 setAtivosTranferir(false)
               }

                const Tranferir = ()=>{
                 setPag1(true);
                  setAtivosTranferir(true)
               }

               const Pagina2 = async (id , List)=>{
                await setId(id);
                await setListEsp(List);
                await setPag1(true);
                await setPag2(true);

              }

                const MsgDesativar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("Desativar");
                  
                }

                const Desativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:false } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TADesativandoCateg(Dados, Id, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

                const MsgAtivar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("ativar");
                  
                }

                 const Ativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:true } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TAAtivandoCateg(Dados, Id, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }
                 const LimpandoPesq = ()=>{
                    ListApp() 
                  }
            const printValue5 = (target) => {
        
           setIdContRes(target.value)
           setContasNome(target.label)
           setContasTel(target.Tel)
           }
           const printValue6 = (target) => {
            
           setIdContRes(target.value)
           setContasNome(target.Nome)
           setContasTel(target.label)
           }
               
      
  return (
        
          <div>
             {Alert !== " " && AlertTipo === "success" &&
                  <SweetAlert  success title={Alert} onConfirm={confirma} onCancel={cancelar} />
                }

            {Alert !== " " && AlertTipo === "danger" &&
                  <SweetAlert  danger title={Alert} confirmBtnBsStyle="danger" onConfirm={confirma} onCancel={cancelar} />
                }


            { Alert !== " " && AlertTipo === "Desativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Desativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja Desativar a condicional {Nome}!
            </SweetAlert>
            }
            { Alert !== " " && AlertTipo === "ativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Ativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja ativar a condicional {Nome}!
            </SweetAlert>
            }
            { Pag1 === false ?
            <div className="content-wrapper">
               
              <HeaderPage
              Avisando={Avisando} 
              Titulo={Titulo}
              />            
              <section className="content">
                <div className="container-fluid">
                  
                <div className="row">
                  <section className="col-12">
                  {Loading === true ?
                        <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                        :
                        <>
                     {/* <div className="card card-info">
                    <div className="card-header">
                        <h3 className="card-title">Filtros para pesquisa</h3>
                    </div>
                 
                    <div className="card-body">
                    <div className="row" >
                    <div className="col-sm-2">
                            <div className="form-group">
                                <label>Compras</label>
                                <select className="form-control"
                                value={ResuComp}
                                onChange={t=>setResuComp(t.target.value)} 
                                disabled={VerResuComp}
                                >
                                <option>Escolha  </option>
                                
                                </select>
                                
                              
                            </div>
                            </div>
                      

                        <div className="col-sm-2">
                            <div className="form-group" style={{marginTop:35}}>
                              
                            <Butao 
                            style={"btn btn-sm btn-secondary"}
                            titulo={"Limpar Pesquisa"}
                            onClick={()=>LimpandoPesq()}
                            />
                            </div>
                            </div> 


                    </div>
                    </div>
                    </div> */}
                     <div className="row">
                      <CaixaInforme 
                      cor={"small-box bg-success"}
                      valor={Quant}
                      porcentagen={false}
                      nome={"Quant. Categorias"}
                      icon={"fas fa-bezier-curve"}
                      link={false}
                      />
                      {/* <CaixaInforme 
                      cor={"small-box bg-success"}
                      valor={"53"}
                      porcentagen={true}
                      nome={"Rendimentos"}
                      icon={"ion ion-stats-bars"}
                      link={false}
                      />
                      <CaixaInforme 
                      cor={"small-box bg-warning"}
                      valor={"44"}
                      porcentagen={false}
                      nome={"Contas Subordinadas"}
                      icon={"ion ion-person-add" }
                      link={false}
                      />
                      <CaixaInforme 
                      cor={"small-box bg-danger"}
                      valor={"65"}
                      porcentagen={false}
                      nome={"Visitas"}
                      icon={"ion ion-pie-graph"}
                      link={false}
                      />                            */}
                   </div>
                          {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                    <>
                      {InfIdConta.MensagemSistem.Ativo &&
                    <div class="alert alert-warning alert-dismissible">
                            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                            <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                            {InfIdConta.MensagemSistem.Msg}
                          </div>
                      }
                      </>   
                      }

                      {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.TempLimitAtiv < new Date().getTime() &&
                      <div class="alert alert-danger alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                             A mensalidade da sua conta vence em {new Date(InfIdConta.TempLimitAtiv).toLocaleDateString('pt-BR')}. Entre em contato com a empresa e realize o pagamento. Caso o pagamento não seja efetuado em até 5 dias após o vencimento, os aplicativos dos seus alunos serão bloqueados. 
                            </div>
                        }
                        </>   
                        }
                    <div className="card card-warning">
                     {DadCont === "Emp" &&
                              <>
                        <div style={{margin:"10px", width:"250px"}}>
                        <Butao 
                        style={"btn btn-sm btn-success"}
                        titulo={"Criar Categoria"}
                        onClick={()=>Pagina1()}
                        /><br />
                         </div>
                          <div style={{margin:"10px", width:"250px"}}>
                        <Butao 
                        style={"btn btn-sm btn-success"}
                        titulo={"Transferir Categoria"}
                        onClick={()=>Tranferir()}
                        /><br />
                         </div>
                         </>
                         }
                       {DadCont === "Emp" &&
                              <>
      
                        {ListContas.length !== 0 &&
                        <>
                    
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasNome}
                      onChange={(target) => printValue5(target)}
                      options={ListContas}
                      placeholder={"Escolha  o Nome "}
                    />    
                    
                  </div> 
                    <div  style={{width:250, marginBottom:10, marginLeft:5}}>
                      <Select
                        defaultValue={ContasTel}
                      onChange={(target) => printValue6(target)}
                      options={ListContasTel}
                      placeholder={"Escolha  o Telefone"}
                    />    
                    
                  </div> 
                  <string style={{marginBottom:10, marginLeft:5}}>Cliente: {ContasNome} - Tel: {ContasTel}</string>
                    
                  </>
                      }
                        </>
      
                              }
                       
                      
                      <div className="card-header">
                      
                        <h3 className="card-title" style={{ marginBottom: "10px"}}>Lista Categorias de Exercícios  </h3> 

                      </div>
                        <div class="card-body table-responsive p-0">
                          <table class="table table-hover text-nowrap">
                            <thead>
                              <tr>
                                <th>Ações</th>
                                <th>Nome</th>
                                
                                <th>Ativo</th>
                                
                                
                              </tr>
                            </thead>
                            
                            { Lista[0].list ?
                            <tbody >
                            {Lista.map((item, key)=>(
                            
                            
                                    <tr key={item.list.Id} style={{backgroundColor: item.list.Ativo=== false ?"#F4B0B9":"#FFF"}} >
                                     <td>
                                    
                                    {item.list.Ativo===true ?
                                    <>
                               
                                    <Butao 
                                    style={"btn btn-xs btn-success"}
                                    titulo={"Vizializar"}
                                    onClick={()=>Pagina2(item.list.Id, item.list)}
                                    />
                                      
                                   {Dados &&
                                    <>
                                      {Dados.Categorias.Btn.botão_Desativar &&
                                      <>
                                      <Butao 
                                      style={"btn btn-xs btn-secondary"}
                                      titulo={"Desativar"}
                                      onClick={()=>Desativar(item.list.Id, item.list.Nome)}
                                      />
                                        </>
                                        }
                                        </>
                                        }
                                                                     
                                      
                                      </>
                                      :
                                      <>
                                  
                                      <Butao 
                                      style={"btn btn-xs btn-success"}
                                      titulo={"Vizualizar"}
                                      onClick={()=>Pagina2(item.list.Id, item.list)}
                                      /> 
                                     {Dados &&
                                       <>
                                      {Dados.Categorias.Btn.botão_Ativar &&
                                      <>
                                      <Butao 
                                      style={"btn btn-xs btn-warning"}
                                      titulo={"Ativar"}
                                      onClick={()=>Ativar(item.list.Id, item.list.Nome)}
                                      /> 
                                            </>
                                            }
                                            </>
                                            }
                                    
                                      </>
                                    }                                     
                                                           
                                    </td>
                                    
                                    <td>{item.list.Nome}</td>
                                   
                                    <td>
                                      {item.list.Ativo===true ?
                                      <span style={{ fontSize: "13px" }}>Ativo</span> 
                                      :
                                      <span style={{ color: "red", fontSize: "13px" }} >Desativo</span> 
                                    }                                   
                                                               
                                    </td>
                                   
                                   
                                  </tr>
                                 
                             ))}
                                </tbody> 
                                :
                                      <>
                                      { Carreg === true ?
                                        <>   
                                        <div className="progress" style={{ height: "25px" }}>
                                          <div
                                            className="progress-bar bg-primary progress-bar-striped"
                                            role="progressbar"
                                            style={{ width: `${Progress}%` }}
                                            aria-valuenow={Progress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          >
                                            {Progress.toFixed(2)}% Completo
                                          </div>
                                        </div>
                                         <p style={{ margin:"20px"}}>Espere, Estamos Preparando a lista.</p>
                                         </>
                                        :                                      
                                      <p style={{color:"red", margin:"20px"}}>Não existe Categoria Cadastrada </p>
                                      }
                                      </>
                            }
                            
                            
                          </table>
                            <Pagination
                            limit={Limit} 
                            total={Quant} 
                            offset={Offset}
                            setOffset={setOffset}
                            />
                         </div>
                        </div>
                       
                        </>
                        }
                    </section>       
               </div>
            </div>
          </section>
        </div>
        :
        <>
        {Pag2 === false ?
        <>
        {AtivosTranferir ?
         <TATransferirCat
          DadCont={DadCont}
          ListContas={ListContas}
          ListContasTel={ListContasTel}
          setAddList={setAddList}
          setUsuariosContServ={setUsuariosContServ}
          UsuariosContServ={UsuariosContServ}
          setAlert={setAlert}
          setAlertTipo={setAlertTipo}
          Avisando={Avisando}
          Fechar={Fechar}
          Dados={Dados}
          Id={Id}
          Nome={Nome}
          IdConta={IdConta} 
            />

          :

          <TACriarCat
          DadCont={DadCont}
          ListContas={ListContas}
          ListContasTel={ListContasTel}
          setAddList={setAddList}
          setUsuariosContServ={setUsuariosContServ}
          UsuariosContServ={UsuariosContServ}
          setAlert={setAlert}
          setAlertTipo={setAlertTipo}
          Avisando={Avisando}
          Fechar={Fechar}
          Dados={Dados}
          Id={Id}
          Nome={Nome}
          IdConta={IdConta} 
            />
            }
            </>
          :
          <TAEditarCatg
            DadCont={DadCont} 
            setUsuariosContServ={setUsuariosContServ}
            UsuariosContServ={UsuariosContServ}
            setAlert={setAlert}
            setAlertTipo={setAlertTipo}
            Avisando={Avisando}
            Fechar={Fechar}
            Dados={Dados}
            Id={Id}
            IdConta={IdConta}
            ListEsp={ListEsp}
            ContasTel={ContasTel}
            ContasNome={ContasNome}
            />
        }
        
        </>
   
         }
      </div>

        );
    }

